import { Injectable } from '@angular/core';

@Injectable()
export class TypematiereModel {

  constructor() { }
  public lib_typmatiere:string;
  public id_cycle:string;
}